var _defs, _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchVisualisation = function SvgSearchVisualisation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".search-visualisation_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 23.5h-11a1 1 0 0 1-1-1v-21a1 1 0 0 1 1-1h13.29a1 1 0 0 1 .71.293L19.2 4.5a1 1 0 0 1 .293.707V9.5M3.497 15.5h6",
    className: "search-visualisation_svg__a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.5h1a.5.5 0 0 1 .5.5v4.5h0-2 0V11a.5.5 0 0 1 .5-.5M10.5 12.5V8a.5.5 0 0 0-.5-.5H9a.5.5 0 0 0-.5.5v7.5",
    className: "search-visualisation_svg__a"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.026,
    cy: 17.029,
    r: 4.529,
    className: "search-visualisation_svg__a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m23.497 23.5-3.248-3.248",
    className: "search-visualisation_svg__a"
  })));
};
export default SvgSearchVisualisation;